"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'NDP公式アプリ',
    organizationId: 'ndpXfGtJKFhgHjdZr3cl',
    applicationKey: 'ndp',
    applicationType: 'organization',
    artistId: undefined,
    ionicAppId: '18e2849e',
    platform: ['web', 'native'],
    ios: {
        bundleId: 'com.utoniq.ndp',
        appId: '6448327656',
    },
    android: {
        bundleId: 'com.utoniq.ndp2',
    },
    deeplinkUrl: 'https://ndp.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/3562292',
    applink: 'ndp.utoniq.com',
    deeplinkProd: 'ndp.utoniq.com',
    custom: {
        modules: {
            trade: true,
            thread: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            item: true,
            store: true,
            campaign: true,
            mission: true,
            resale: true,
            preSale: true,
            event: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
        ],
        globalTabs: ['home', 'notifications', 'myProfile'],
        artistTabs: ['home', 'collections', 'gachas', 'trade', 'threads'],
    },
});
